export default "__VITE_PUBLIC_ASSET__e3ca00d7__"